<template>
  <div class="qf-table-cell" :style="{ width: column.width + 'px', textAlign: column.align }">
    <!-- 如果列定义了 render 函数，渲染组件 -->
    <component v-if="column?.render" :key="row?.[column.colKey]" :is="getRender" />
    <!-- 否则如果有插槽使用插槽 -->
    <slot v-else-if="column.slotName" :name="column.slotName" :row="row" :column="column" :value="row?.[column.colKey]" :index="colIndex"> </slot>
    <!-- 否则走默认值 -->
    <template v-else> {{ row?.[column.colKey] ?? '-' }}</template>
    <slot></slot>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  column: {
    type: Object,
    default: () => {}
  },
  row: {
    type: Object,
    default: () => {}
  },
  colIndex: {
    type: Number,
    default: 0
  }
});

//使用computed属性调用function，避免components组件每次重新调用函数
const getRender = computed(() => {
  return props.column.render(props.row);
});
</script>

<style scoped lang="less">
@import './qf-table-cell.less';
</style>
